import { Link, useLocation } from "react-router-dom";

export function Header() {
  const { pathname } = useLocation();
  const area = pathname.startsWith("/review") ? "Review" : "Apply";
  return (
    <header className="site-header">
      <div className="site-bar">
        <Link to={area === "Review" ? "/review" : "/"} className="brand">
          <img
            src="/brand/logo-black.png"
            alt="Tekdi Technologies"
            className="logo logo-light"
            width={46}
            height={40}
          />
          <img
            src="/brand/logo-white.png"
            alt=""
            aria-hidden="true"
            className="logo logo-dark"
            width={46}
            height={40}
          />
          <span className="brand-area">{area}</span>
        </Link>
      </div>
    </header>
  );
}
